/**
 * Custom error class for validation errors that should display their
 * specific message to users instead of routing through generic error handlers.
 *
 * Use this when throwing errors for user input validation that needs to show
 * a specific, actionable message.
 *
 * @example
 * throw new ValidationError('The selected date is unavailable');
 */
export class ValidationError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'ValidationError';

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ValidationError);
        }
    }
}
